import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AircraftState } from './aircraft.state';

const selectAircraftSelector = createFeatureSelector<AircraftState>('aircraft');

// Aircraft
export const selectAllAircraftState = createSelector(
  selectAircraftSelector,
  state => state.aircrafts
);

export const selectIsAircraftLoadingState = createSelector(
  selectAircraftSelector,
  state => state.loading
);

// Aircraft Makes
export const selectAllAircraftMakesState = createSelector(
  selectAircraftSelector,
  state => state.aircraftMakes
);

// Aircraft Models
export const selectAllAircraftModelsState = createSelector(
  selectAircraftSelector,
  state => state.aircraftModels
);

// APU Models
export const selectAllApuModelsState = createSelector(
  selectAircraftSelector,
  state => state.apuModels
);
